import { useEffect, useRef } from "react";
import { socketService } from "../socketService";
import { SocketEvents } from "../socketEvents";

export const useSocketListener = (
  event: SocketEvents,
  callback: (data: any) => void
) => {
  // Keep callback stable
  const savedCallback = useRef(callback);
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    if (import.meta.env.DEV) {
      console.log(`[Hook] Subscribing to: ${event}`);
    }

    const unsubscribe = socketService.subscribe(event, (data) => {
      if (import.meta.env.DEV) {
        console.log(`[Hook] Triggered: ${event}`);
      }
      savedCallback.current(data);
    });

    return () => {
      if (import.meta.env.DEV) {
        console.log(`[Hook] Unsubscribing: ${event}`);
      }
      unsubscribe();
    };
  }, [event]);
};
